/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Routing from "./Routing";
import CToast from "../basecomp/components/CToast";
import { useToast } from "../basecomp/components/provider/ToastProvider";
import Header from "../basecomp/main/Header";
import Services from "../basecomp/main/Services";
import UserUtils from "../basecomp/auth/UserUtils";
import LoginView from "../basecomp/auth/view/LoginView";
import ConasLogo from "./assets/conas_logo.png";
import ConasLogo2 from "../home/assets/conas_logo2.png";
import ConasLogoSmall from "./assets/logo512.png";
import BgImg from "./assets/portbg_blur.png";
import warehouseimg from "../home/assets/warehouse.png";
import dcatimg from "../home/assets/d-catalogue.png";
import glnimg from "../home/assets/gln.jpg";
import PrintingView from "../label_print/src/view/PrintingView";
import BinLocationView from "../label_print/src/view/BinLocationView";
import InventoryView from "../label_print/src/view/InventoryView";
import UploadLabelView from "../label_print/src/view/UploadLabelView";
import ImageUploadView from "../image_upload/src/view/ImageUploadView";
import RegistrationDataView from "../gsone/src/view/RegistrationView";
import SparePartInfoView from "../gsone/src/view/SparePartInfoView";
import FuelAssetInfoView from "../gsone/src/view/FuelAssetView";
import HistoricalJob from "../d_catalogue/src/hist_jods/view/HistoricalJob";
import ShoppingBasket from "../d_catalogue/src/sp_basket/view/ShoppingBasket";
import HistoricalJobDetails from "../d_catalogue/src/hist_jods/view/HistoricalJobDetails";
import ERPImplementationPage from "../home/src/ERPImplementation";
import HomePage from "../home/src//Home";
import MDMPage from "../home/src/MasterDataManagement";
import WarehousePage from "../home/src/WarehouseManagement";
import PowerBIPage from "../home/src/PowerBI";
import DCataloguePage from "../home/src/DCatalogue";
import FuelManagementPage from "../home/src/FuelManagement";
import DigitalLinkPage from "../home/src/DigitalLink";
import IndustryVerticlesPage from "../home/src/IndustryVerticles";
import AboutPage from "../home/src/About";
import ContactPage from "../home/src/Contact";
import New from "../home/src/New";
import WareHouseView from "../label_print/src/view/WarehouseLocation";
import ResolverHeader from "../basecomp/main/ResolverHeader";
import WareHouseCounting from "../label_print/src/view/WarehouseCounting";
import MaintenancePage from "../basecomp/components/Maintenance";
import tracker from "../tracker/UserActivityTracker";
import DataUpload from "../label_print/src/view/DataUpload";
import IssueReceiveLanding from "../label_print/src/view/IssueReceiveLanding";
import ReceiveView from "../label_print/src/view/ReceiveView";
import IssueView from "../label_print/src/view/IssueView";
import MaterialSearch from "../label_print/src/view/MaterialSearch";
import RCA from "../label_print/src/pages/RcaPage";

export const checkPermission = (permissionKey) => {
  let localData = localStorage.getItem("permissionData");
  console.log(localData);
  if (!localData) return false;
  localData = JSON.parse(localData)

  try {
    const permissionsArray = typeof localData === 'string'
      ? localData.split(',').map(p => p.trim())
      : localData;
    console.log(permissionsArray);
    console.log(permissionsArray.includes(permissionKey));
    return permissionsArray.includes(permissionKey);
  } catch (error) {
    console.error('Error checking permission:', error);
    return false;
  }
};

const AppContent = () => {
  const { t } = useTranslation();
  const { handleLogin, handleLogout, getUserName, getInitials } = UserUtils;
  const currentUrl = window.location.href;
  const urlParams = new URL(currentUrl).searchParams;
  const loginParam = urlParams.get("login");
  const pathName = new URL(currentUrl).pathname;
  const isLoginReturn = loginParam === "true" && pathName === "/login";
  const [isReadyToRender, setIsReadyToRender] = useState(!isLoginReturn);
  const createInitialServices = useCallback(
    () => [
      {
        key: "tool_dcat",
        title: t("d") + "-" + t("catalogue"),
        route: "/d-catalogue/shopping-basket",
        asset: dcatimg,
      },
      {
        key: "tool_warehouse",
        title: t("warehouse_management"),
        route: "/warehouse/label-printing",
        asset: warehouseimg,
      },
      {
        key: "tool_gln",
        title: t("global_loc"),
        route: "https://global-location-data.conasservices.com/",
        asset: glnimg,
      },
    ],
    [t]
  );
  const [services, setServices] = useState(createInitialServices);
  const [isPermissionLoaded, setIsPermissionLoaded] = useState(false);
  const [dataInitialized, setDataInitialized] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingRedirectPath, setPendingRedirectPath] = useState("");
  const [modalDismissed, setModalDismissed] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const { handleToastOpen } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathName = location.pathname;
  const preventModalRef = useRef(isLoginReturn);
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [maintenanceConfig, setMaintenanceConfig] = useState({
    startDate: "",
    endDate: "",
    formattedStartDate: "",
    formattedEndDate: "",
    message: t("deploy_msg"),
  });

  useEffect(() => {
    const updatedServices = createInitialServices();
    if (isPermissionLoaded) {
      const localData = localStorage.getItem("permissionData");
      if (localData) {
        try {
          const permissionsArray =
            typeof localData === "string" ? JSON.parse(localData) : localData;

          const servicesWithPermissions = updatedServices.map((service) => ({
            ...service,
            isEnabled: permissionsArray.includes(service.key),
            path: service.route,
          }));

          setServices(servicesWithPermissions);
        } catch (error) {
          setServices(updatedServices);
        }
      } else {
        setServices(updatedServices);
      }
    } else {
      setServices(updatedServices);
    }
  }, [createInitialServices, isPermissionLoaded]);

  const protectedRoutes = [
    "/services",
    "/d-catalogue/shopping-basket",
    "/d-catalogue/historical-job",
    "/d-catalogue/historical-job-detail",
    "/warehouse/label-printing",
    "/warehouse/label-upload",
    "/warehouse/image-upload",
    "/warehouse/sap-bin-location",
  ];

  const isProtectedRoute = useCallback(() => {
    return protectedRoutes.some(
      (route) => currentPathName.startsWith(route) || currentPathName === route
    );
  }, [currentPathName]);

  useEffect(() => {
    if (isLoginReturn) {
      const timer = setTimeout(() => {
        setIsReadyToRender(true);
        const token = localStorage.getItem("token");
        if (token) {
          navigate("/services", { replace: true });
        }
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [isLoginReturn, navigate]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isAuth = !!token;
    setIsAuthenticated(isAuth);
    setIsInitialized(true);

    if (isLoginReturn) {
      setShowAuthModal(false);
      setModalDismissed(true);
      preventModalRef.current = true;
      return;
    }

    const hasLoginParam = loginParam === "true";
    const storedEmail = sessionStorage.getItem("email");
    const isLegitimateAuthFlow = hasLoginParam && storedEmail;

    if (isLegitimateAuthFlow) {
      setShowAuthModal(false);
      setModalDismissed(true);
      preventModalRef.current = true;
      return;
    }

    if (!isAuth && isProtectedRoute()) {
      if (currentPathName !== "/login") {
        sessionStorage.setItem("redirectAfterLogin", currentPathName);
        setShowAuthModal(true);
        setPendingRedirectPath(currentPathName);
        navigate("/login", { replace: true });
      }
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "token" || e.type === "cStorage") {
        const newToken = localStorage.getItem("token");
        const wasAuthenticated = isAuthenticated;
        const nowAuthenticated = !!newToken;

        if (!wasAuthenticated && nowAuthenticated) {
          preventModalRef.current = true;

          setIsAuthenticated(true);
          setShowAuthModal(false);
          setModalDismissed(true);
          setPendingRedirectPath("");

          if (isLoginReturn) {
            setIsReadyToRender(true);
          }

          setTimeout(() => {
            const redirectPath = sessionStorage.getItem("redirectAfterLogin");
            if (redirectPath && redirectPath !== "/login") {
              sessionStorage.removeItem("redirectAfterLogin");
              navigate(redirectPath, { replace: true });
            } else if (currentPathName === "/login") {
              navigate("/services", { replace: true });
            } else {
              navigate("/services", { replace: true });
            }
          }, 200);
        } else if (wasAuthenticated && !nowAuthenticated) {
          preventModalRef.current = false;
          setIsAuthenticated(false);
          setModalDismissed(false);
          if (isProtectedRoute()) {
            navigate("/login", { replace: true });
          }
        } else {
          setIsAuthenticated(nowAuthenticated);
        }
      }
    };

    const handleCustomStorageChange = () => {
      handleStorageChange({ type: "cStorage" });
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("cStorage", handleCustomStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("cStorage", handleCustomStorageChange);
    };
  }, [
    isAuthenticated,
    navigate,
    isProtectedRoute,
    isLoginReturn,
    currentPathName,
  ]);

  useEffect(() => {
    if (!isReadyToRender) return;
    if (isLoginReturn) {
      setShowAuthModal(false);
      return;
    }
    if (preventModalRef.current) {
      setShowAuthModal(false);
      return;
    }

    const token = localStorage.getItem("token");
    if (token || isAuthenticated) {
      setShowAuthModal(false);
      return;
    }

    if (currentPathName === "/login" && !modalDismissed) {
      const redirectPath = sessionStorage.getItem("redirectAfterLogin");
      if (redirectPath) {
        const timeoutId = setTimeout(() => {
          if (!localStorage.getItem("token") && !preventModalRef.current) {
            setShowAuthModal(true);
            setPendingRedirectPath(redirectPath);
          }
        }, 1000);

        return () => clearTimeout(timeoutId);
      }
    }
  }, [
    currentPathName,
    modalDismissed,
    isAuthenticated,
    isLoginReturn,
    isReadyToRender,
  ]);

  const handleAuthModalOk = () => {
    setShowAuthModal(false);
    setPendingRedirectPath("");
    setModalDismissed(true);
    preventModalRef.current = true;
    sessionStorage.clear();
    window.location.reload();
  };

  const handleAuthModalClose = () => {
    setShowAuthModal(false);
    setPendingRedirectPath("");
    setModalDismissed(true);
    preventModalRef.current = true;
    sessionStorage.removeItem("redirectAfterLogin");
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const checkMaintenancePeriod = () => {
      const currentDate = new Date();
      const isMaintenance =
        currentDate >= maintenanceConfig.startDate &&
        currentDate <= maintenanceConfig.endDate;
      setIsMaintenanceMode(isMaintenance);
    };

    checkMaintenancePeriod();
  }, [maintenanceConfig.startDate, maintenanceConfig.endDate]);

  useEffect(() => {
    if (
      isMaintenanceMode &&
      currentPathName !== "/" &&
      currentPathName !== "/login"
    ) {
      navigate("/login");
    }
  }, [isMaintenanceMode, currentPathName, navigate]);

  const isHeader = !(
    currentPathName.includes("/warehouse/spare-part-info") ||
    currentPathName.includes("/login") ||
    currentPathName.includes("/warehouse/whs-location-info") ||
    currentPathName.includes("/warehouse/asset-info") ||
    currentPathName.includes("/warehouse/registration-asset")
  );
  const isLoginHeader =
    !!currentPathName &&
    currentPathName !== "/" &&
    currentPathName !== "/login";
  const resolverToolHeader = !isHeader && isLoginHeader;

  const userStateRef = useRef({
    userName: getUserName() || "",
    userInitials: getInitials() || "",
    isLoaded: !!(getUserName() && getInitials()),
  });

  const [userState, setUserState] = useState(userStateRef.current);

  const checkIntervalRef = useRef(null);
  const pollingTimeoutRef = useRef(null);

  const clearAllTimers = useCallback(() => {
    if (checkIntervalRef.current) {
      clearInterval(checkIntervalRef.current);
      checkIntervalRef.current = null;
    }
    if (pollingTimeoutRef.current) {
      clearTimeout(pollingTimeoutRef.current);
      pollingTimeoutRef.current = null;
    }
  }, []);

  const refreshUserInfo = useCallback(() => {
    const storedUserName = getUserName();
    const storedInitials = getInitials();

    if (
      (storedUserName !== userStateRef.current.userName ||
        storedInitials !== userStateRef.current.userInitials) &&
      storedUserName &&
      storedInitials
    ) {
      userStateRef.current = {
        userName: storedUserName,
        userInitials: storedInitials,
        isLoaded: true,
      };

      setUserState(userStateRef.current);
      return true;
    }

    return !!userStateRef.current.isLoaded;
  }, []);

  const updateServicesPermissions = useCallback(() => {
    const localData = localStorage.getItem("permissionData");

    if (localData) {
      try {
        const permissionsArray =
          typeof localData === "string" ? JSON.parse(localData) : localData;

        if (!isPermissionLoaded) {
          const updatedServices = createInitialServices().map((service) => ({
            ...service,
            isEnabled: permissionsArray.includes(service.key),
            path: service.route,
          }));

          setServices(updatedServices);
          setIsPermissionLoaded(true);
        }
        return true;
      } catch (error) {
        if (!isPermissionLoaded) {
          setServices(createInitialServices());
          setIsPermissionLoaded(true);
        }
        return true;
      }
    }
    return isPermissionLoaded;
  }, [createInitialServices, isPermissionLoaded]);

  useEffect(() => {
    const checkAndLoadData = () => {
      const userDataLoaded = refreshUserInfo();
      const permissionDataLoaded = updateServicesPermissions();
      return userDataLoaded && permissionDataLoaded;
    };

    if (!checkAndLoadData() && !dataInitialized) {
      checkIntervalRef.current = setInterval(() => {
        if (checkAndLoadData()) {
          clearAllTimers();
          setDataInitialized(true);
        }
      }, 500);

      pollingTimeoutRef.current = setTimeout(() => {
        clearAllTimers();
        setDataInitialized(true);
      }, 5000);
    } else {
      setDataInitialized(true);
    }

    const handleStorageChange = () => {
      refreshUserInfo();
      updateServicesPermissions();
    };
    window.addEventListener("cStorage", handleStorageChange);
    return () => {
      window.removeEventListener("cStorage", handleStorageChange);
      clearAllTimers();
    };
  }, []);

  const [pageTitle, setPageTitle] = useState("");


  const appRouteMap = useMemo(
    () => ({
      "/": {
        element: isMaintenanceMode ? (
          <MaintenancePage
            startDate={maintenanceConfig.formattedStartDate}
            endDate={maintenanceConfig.formattedEndDate}
            message={maintenanceConfig.message}
            cLogo={ConasLogo}
            cBgImg={BgImg}
          />
        ) : (
          <HomePage />
        ),
      },
      "/login": {
        element: (
          <LoginView
            cLogo={ConasLogo}
            cBgImg={BgImg}
            handleToastOpen={handleToastOpen}
          />
        ),
      },
      "/services": {
        title: t("services"),
        d_route: t("services"),
        element: <Services services={services} linkComponent={Link} />,
      },
      "/ERP-Implementation": {
        element: <ERPImplementationPage />,
      },
      "/MDM": {
        element: <MDMPage />,
      },
      "/Warehouse": {
        element: <WarehousePage />,
      },
      "/PowerBI": {
        element: <PowerBIPage />,
      },
      "/DCatalogue": {
        element: <DCataloguePage />,
      },
      "/FuelManagement": {
        element: <FuelManagementPage />,
      },
      "/DigitalLink": {
        element: <DigitalLinkPage />,
      },
      "/IndustryVerticles": {
        element: <IndustryVerticlesPage />,
      },
      "/About": {
        element: <AboutPage />,
      },
      "/Contact": {
        element: <ContactPage />,
      },
      "/New": {
        element: <New />,
      },
      "/d-catalogue/historical-job": {
        title: t("d") + "-" + t("catalogue"),
        d_route: t("historical_job"),
        element: <HistoricalJob />,
        isDrawer: true,
      },
      "/d-catalogue/historical-job-detail": {
        title: t("d") + "-" + t("catalogue"),
        d_route: t("historical_job_detail"),
        element: <HistoricalJobDetails />,
        isDrawer: false,
      },
      "/d-catalogue/shopping-basket": {
        title: t("d") + "-" + t("catalogue"),
        d_route: t("shopping_basket"),
        element: <ShoppingBasket />,
        isDrawer: true,
      },
      ...(checkPermission("material_search") && {
        "/warehouse/material-search": {
          title: t("Material Search"),
          d_route: t("Material Search"),
          element: <MaterialSearch />,
          isDrawer: true,
        },
      }),
      "/warehouse/label-printing": {
        title: t("label_printing"),
        d_route: t("label_printing"),
        element: <PrintingView />,
        isDrawer: true,
      },
      "/warehouse/label-upload": {
        title: t("bulk_upload"),
        d_route: t("bulk_upload"),
        element: <UploadLabelView />,
        isDrawer: true,
      },
      "/warehouse/image-upload": {
        title: t("material_images"),
        d_route: t("material_images"),
        element: <ImageUploadView />,
        isDrawer: true,
      },
      "/warehouse/registration-asset": {
        title: t("registration"),
        d_route: t("registration"),
        element: <RegistrationDataView />,
        isDrawer: false,
      },
      "/warehouse/spare-part-info": {
        title: t("spare_part_info"),
        d_route: t("spare_part_info"),
        element: <SparePartInfoView />,
        isDrawer: false,
      },
      "/warehouse/whs-location-info": {
        title: t("warehouse_loc_info"),
        d_route: t("warehouse_loc_info"),
        element: <WareHouseView />,
        isDrawer: false,
      },
      "/warehouse/whs-location-info/counting": {
        title: t("material_counting"),
        d_route: t("material_counting"),
        element: <WareHouseCounting />,
        isDrawer: false,
      },
      "/warehouse/asset-info": {
        title: t("asset_info"),
        d_route: t("asset_info"),
        element: <FuelAssetInfoView />,
        isDrawer: false,
      },
      "/warehouse/sap-bin-location": {
        title: t("bin_location_details"),
        d_route: t("bin_location_details"),
        element: <BinLocationView />,
        isDrawer: true,
      },
      "/warehouse/rca": {
        title: t("rca"),
        d_route: t("rca"),
        element: <RCA />,
        isDrawer: true,
      },
      "/warehouse/reports": {
        title: t("Reports"),
        d_route: t("Reports"),
        element: <InventoryView />,
        isDrawer: true,
      },
      ...(checkPermission("issue_receive") && {
        "/warehouse/issue-receive": {
          title: t("issue_receive"),
          d_route: t("issue_receive"),
          element: <IssueReceiveLanding />,
          isDrawer: true,
        },
      }),
      ...(checkPermission("issue_receive") && {
        "/warehouse/issue-receive/receive": {
          title: t("receive_material"),
          d_route: t("receive_material"),
          element: <ReceiveView />,
          isDrawer: false,
        },
      }),
      ...(checkPermission("issue_receive") && {
        "/warehouse/issue-receive/issue": {
          title: t("issue_material"),
          d_route: t("issue_material"),
          element: <IssueView />,
          isDrawer: false,
        },
      }),
      ...(checkPermission("data_upload") && {
        "/warehouse/data-upload": {
          title: t("Data Upload"),
          d_route: t("Data Upload"),
          element: <DataUpload />,
          isDrawer: true,
        },
      }),
    }),
    [t, services, isMaintenanceMode, maintenanceConfig, handleToastOpen]
  );

  const drawerList = ["/warehouse", "/d-catalogue"];

  useEffect(() => {
    const pathname = location.pathname;
    let title = "";
    if (appRouteMap[pathname]) {
      title = appRouteMap[pathname].title || "";
    }
    setPageTitle(title);
  }, [location.pathname, appRouteMap]);

  useEffect(() => {
    tracker.startTracking();
    return () => tracker.stopTracking();
  }, []);

  useEffect(() => {
    tracker.trackPageChange(location.pathname);
  }, [location.pathname]);

  if (!isInitialized || (isLoginReturn && !isReadyToRender)) {
    return null;
  }

  const shouldShowHeader = isHeader && userState.isLoaded;
  const shouldShowResolverHeader = resolverToolHeader;
  const sessionItem = sessionStorage.getItem("logingsoneurl");
  if (shouldShowHeader && sessionItem) {
    navigate(sessionItem);
  }
  const storedEmail = sessionStorage.getItem("email");
  const hasLoginParam = loginParam === "true";
  const isLegitimateAuthFlow = hasLoginParam && storedEmail;
  const shouldShowModal =
    isReadyToRender &&
    !isLegitimateAuthFlow &&
    showAuthModal &&
    !preventModalRef.current &&
    !isAuthenticated;

  return (
    <>
      <Dialog
        open={shouldShowModal}
        onClose={() => { }}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: 4,
            padding: 3,
            boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
            border: "none",
            background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            backdropFilter: "blur(4px)",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "700",
            fontSize: "1.5rem",
            color: "#1565c0",
            pb: 2,
            pt: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <span style={{ fontSize: "2rem" }}>🔒</span>
          {t("auth_req")}
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", py: 3 }}>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "#475569",
              fontSize: "1.1rem",
              lineHeight: 1.6,
              fontWeight: "400",
            }}
          >
            {t("login_unauth")}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 4, pt: 2 }}>
          <Button
            onClick={handleAuthModalOk}
            variant="contained"
            size="large"
            sx={{
              borderRadius: 3,
              px: 6,
              py: 1.5,
              fontSize: "1.1rem",
              fontWeight: "600",
              textTransform: "none",
              background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
              boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
              border: "1px solid rgba(255,255,255,0.2)",
              "&:hover": {
                background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
                boxShadow: "0 8px 25px rgba(25, 118, 210, 0.5)",
                transform: "translateY(-1px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            {t("close")}
          </Button>
        </DialogActions>
      </Dialog>

      {shouldShowHeader && (
        <Header
          cLogo={ConasLogo}
          cLogoSmall={ConasLogoSmall}
          handleLogin={handleLogin}
          handleLogout={handleLogout}
          cUserName={userState.userName}
          cUserInitials={userState.userInitials}
          pageTitle={pageTitle}
          appRouteMap={appRouteMap}
          drawerList={drawerList}
          pathName={currentPathName}
          navigate={navigate}
          linkComponent={Link}
        />
      )}
      {shouldShowResolverHeader && (
        <ResolverHeader cLogo={ConasLogo2} pageTitle={pageTitle} />
      )}
      <CToast />
      <Routing appRouteMap={appRouteMap} />
    </>
  );
};

export default AppContent;
